import { useEffect, useState } from 'react';
import { appPath } from '@featit/shared/addressing/paths';
import { myIdeasApi } from '@/services/MyIdeasApi';

/** F-0461 (OF-31): where a reader sees the ideas they reported. */
export const MY_IDEAS_PATH = appPath('/my-ideas');

/**
 * How many ideas this reader reported, asked once per page load — the sidebar line shows only for
 * a reader who has any. `null` until the answer arrives, and after a failure: a failed read draws no
 * line rather than claiming there is nothing.
 */
let asked: Promise<number | null> | null = null;

export function useMyIdeasCount(): number | null {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    let current = true;
    asked ??= myIdeasApi
      .list()
      .then((ideas) => ideas.length)
      .catch(() => {
        asked = null;
        return null;
      });
    void asked.then((answer) => current && setCount(answer));
    return () => {
      current = false;
    };
  }, []);
  return count;
}
